export function createDomElementFromString(value: string): Element{

    if(null == value || value == ''){
        return document.createElement('div');
    }

    let elem = document.createElement('div');
    elem.innerHTML = value.trim();
    return elem.firstElementChild;
}